import { useEffect, useState } from 'react';

export default function HeroSection() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative bg-[#FAF9F7] pt-32 lg:pt-40 pb-16 lg:pb-24 px-8 md:px-12 lg:px-[8%] min-h-[85vh] flex items-center overflow-hidden">
      <div className="w-full grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-6 items-center relative z-10">
        {/* Texto — ocupa 7 columnas */}
        <div className="lg:col-span-7 lg:pr-8">
          <div
            className={`transition-all duration-700 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <h1 className="text-[clamp(2.5rem,5.8vw,4.5rem)] font-extrabold text-[#222222] leading-[1.08] tracking-[-0.02em] mb-6 lg:mb-8">
              LunaFinds<span className="text-[#EBCFD4]">.</span>
            </h1>
          </div>

          <div
            className={`transition-all duration-700 delay-150 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <p className="text-[20px] lg:text-[24px] text-[#222222] leading-[1.4] font-medium mb-4 max-w-lg">
              Recomendaciones honestas de belleza, wellness y hogar.
            </p>
          </div>

          <div
            className={`transition-all duration-700 delay-300 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <p className="text-[16px] lg:text-[18px] text-[#6B6860] leading-relaxed font-light mb-8 lg:mb-10 max-w-lg">
              Solo lo que funciona. Sin ruido. Sin patrocinios.
            </p>
          </div>

          <div
            className={`flex flex-col sm:flex-row gap-4 transition-all duration-700 delay-500 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <a
              href="#categorias"
              className="inline-block px-8 py-3 bg-[#222222] text-white text-[14px] font-medium tracking-[0.05em] rounded-md hover:bg-[#3A3A3A] hover:-translate-y-0.5 hover:shadow-md transition-all duration-300 cursor-pointer whitespace-nowrap text-center"
            >
              Ver recomendaciones
            </a>
            <a
              href="#sobre-mi"
              className="inline-block px-8 py-3 bg-transparent border-2 border-[#222222] text-[#222222] text-[14px] font-medium tracking-[0.05em] rounded-md hover:bg-[#222222] hover:text-white hover:-translate-y-0.5 hover:shadow-md transition-all duration-300 cursor-pointer whitespace-nowrap text-center"
            >
              Quién soy
            </a>
          </div>
        </div>

        {/* Imagen — ocupa 5 columnas, ligeramente desplazada */}
        <div
          className={`lg:col-span-5 transition-all duration-900 delay-600 ${
            visible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-12'
          }`}
        >
          <div className="relative w-full h-[400px] lg:h-[500px] lg:ml-6 lg:-mt-4">
            <img
              src="https://static.readdy.ai/image/4c149a989a9058aed7880a7dbbd9f5af/227a46cc132aabfbbe318914bc70e6c2.jpeg"
              alt="Luna - LunaFinds"
              title="Luna LunaFinds belleza bienestar"
              className="w-full h-full object-cover object-top rounded-lg shadow-sm"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
